// extracted by mini-css-extract-plugin
export default {"root":"ActionsCellRenderer_root__RgpoN","menu":"ActionsCellRenderer_menu__J7PYq"};